import { post } from 'axios';
import API from '../../settings/api'
import cookie from 'react-cookies';
import headersWithToken from '../../scripts/helpers/headers.token';

export async function update( store, settings ) {

  try {

    const {

      comission,
      wantedRUB,
      wantedCNY,
      wantedUSD,
      wantedEUR,
      priceWatchMode,
      comissionOrTimeMode

    } = settings;

    const headers = headersWithToken();
    const { data } = await post( API.settings.update, settings, { headers } );

    console.log(`settings update data:`, data);

    store.setState({

      tariff_comission:  comission,
      wanted_result_rub: wantedRUB,
      wanted_result_cny: wantedCNY,
      wanted_result_usd: wantedUSD,
      wanted_result_eur: wantedEUR,
      deal_price_watch_mode: priceWatchMode,
      comission_or_time: comissionOrTimeMode,

    });

    store.actions.popup.hide();

    if ( !data.success ) { throw( data?.error ); } 

  } catch ( err ) {

    console.error( err );

  }
  
}